module.exports = __webpack_public_path__ + "static/media/skill_gap_analysis.49415717.svg";